module.exports = __webpack_public_path__ + "img/index-btn-2.9aa4ad8a.png";